import { use } from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./translations/en";
import { zh } from "./translations/zh";
import { STORAGE_KEYS } from "~/libs/storage-keys";

const getInitialLanguage = () => {
	try {
		const language = localStorage.getItem(STORAGE_KEYS.LANGUAGE);
		if (language === "en" || language === "zh") {
			return language;
		}
	} catch {
		// no-op for restricted storage environments
	}

	return "en";
};

// eslint-disable-next-line react-hooks/rules-of-hooks
void use(initReactI18next).init({
	resources: {
		en: { translation: en },
		zh: { translation: zh },
	},
	lng: getInitialLanguage(),
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});
